import React from "react";

export default function ContactPage() {
  return <h2>ContactPage</h2>;
}
